<template>
  <div class="fooder">
    <div class="w_1200">
      <div class="f_content">
        <div class="f_info">
          <dl>
            <dt>
              <img src="../assets/images/code2.png" alt="" class="logo" />
            </dt>
            <dd>{{ $t("LXDH") }}：0755-84854510</dd>
            <dd>{{ $t("QYYX") }}：zqb@ppmsolution.com</dd>
            <dd>{{ $t("GSADDRESS") }}：{{ $t("ADDRESS01") }}</dd>
          </dl>
        </div>
        <div class="f_menu">
          <div
            class="menu_item"
            v-for="(item, index) in fooderMenu"
            :key="item.id"
          >
            <p class="item_title" @click="to(item)">{{ item.title }}</p>
            <div class="item-con">
              <span v-for="(it, i) in item.child" :key="i" @click="to(it)">{{
                it.title
              }}</span>
            </div>
          </div>
        </div>
        <div class="f_code">
          <div>
            <img src="../assets/images/code.png" class="code" alt="" />
            <div class="code_text">{{ $t("WXGZH") }}</div>
          </div>
        </div>
      </div>
      <div class="copy_right">
        <span>
          CopyRight © 2015 PPM(Shen Zhen) Inc. All Right Reserved.
          <a href="https://beian.miit.gov.cn" targht="_blank"
            >版权所有 粤ICP备10030102号</a
          >
        </span>
      </div>
    </div>
    <div class="phone">
      <div class="p_info">
        <dl>
          <dt>
            <img src="../assets/images/code2.png" alt="" class="logo" />
          </dt>
          <dd>联系电话：0755-84854510</dd>
          <dd>企业邮箱：zqb@ppmsolution.com</dd>
          <dd>公司地址：深圳市龙岗区坪地国际低碳城汇桥路2号</dd>
        </dl>
      </div>
      <div class="p_menu">
        <dl v-for="(item, index) in fooderMenu" :key="index">
          <dt @click="to(item)">
            {{ item.title }}
          </dt>
          <dd v-for="(it, i) in item.child" :key="i" @click="to(it)">
            {{ it.title }}
          </dd>
        </dl>
      </div>
      <div class="p_code">
        <div>
          <img src="../assets/images/code.png" class="code" alt="" />
          <div>微信公众号</div>
        </div>
      </div>
      <div class="copy_right">
        CopyRight © 2015 PPM(Shen Zhen) Inc. All Right Reserved.
        <a href="https://beian.miit.gov.cn" targht="_blank"
          >版权所有 粤ICP备10030102号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fooderMenu: {},
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    to(i) {
      let path = i.url;
      this.$router.push({
        path: path,
        query: i,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fooder {
  width: 100vw;
  background-color: #31b266;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  padding-bottom: 56px;

  .w_1200 {
    .f_content {
      display: flex;
      justify-content: space-between;
      padding: 50px 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);

      dl {
        dt {
          margin-bottom: 8px;
        }

        dd {
          margin-top: 24px;
        }
      }

      .f_info {
        // float: left;
        .logo {
          width: 120px;
          height: 30px;
        }
      }

      .f_menu {
        // float: left;
        width: 56%;
        padding-left: 60px;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
        border-right: 1px solid rgba(255, 255, 255, 0.2);

        .menu_item {
          .item_title {
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
          }

          .item-con {
            margin-top: 24px;
            display: flex;
            flex-wrap: wrap;
            span {
              margin-right: 40px;
              cursor: pointer;
            }

            span:hover {
              color: #ffffff;
            }
          }
        }

        .menu_item:nth-of-type(2) {
          margin-top: 36px;
        }
      }

      .f_code {
        // float: left;
        text-align: center;

        .code {
          width: 104px;
          height: 104px;
          margin-top: 14px;
        }
      }
    }

    .copy_right {
      margin-top: 32px;
      text-align: center;
      a {
		color: rgba(255, 255, 255, 0.8);
		text-decoration: none;
      }
    }
  }
}

.phone {
  width: 100%;
  padding: 20px 0;
  display: none;

  .p_info {
    display: flex;
    align-items: center;
    justify-content: center;

    dl {
      dt {
        margin-bottom: 4px;
      }

      dd {
        margin-top: 12px;
      }
    }
  }

  .p_menu {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .menu_item {
    }

    dl {
      dt {
        margin-bottom: 4px;
        font-size: 16px;
        font-weight: bold;
      }

      dd {
        margin-top: 12px;
      }
    }

    dl:nth-of-type(2) {
      margin-left: 30px;
    }
  }

  .p_code {
    margin-top: 20px;
    text-align: center;

    .code {
      width: 140px;
      height: 140px;
      margin-bottom: 5px;
    }
  }

  .copy_right {
    margin-top: 30px;
    text-align: center;
	a {
		color: rgba(255, 255, 255, 0.8);
		text-decoration: none;
      }
  }
}

@media screen and (max-width: 768px) {
  .fooder {
    padding-bottom: 10px;
  }

  .phone {
    display: block;
  }

  .w_1200 {
    display: none;
  }
}
</style>
